import React, { useState, useRef, useEffect } from "react";
import _ from "lodash";
import { _getBaseUrl } from "../utils/helper";

const DropDown = (props) => {
  const [expanded, setExpanded] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setExpanded(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="relative z-10" ref={dropdownRef}>
      <div
        className={`border border-ideaListGrey100 cursor-pointer ${expanded ? "border-b-0 rounded-tl-md rounded-tr-md" : "rounded-md"}`}
        onClick={() => setExpanded(!expanded)}
      >
        <div className="min-h-[52px] flex items-center gap-2 lg:gap-4 px-2 lg:px-4 py-2">
          <div className="flex-grow opacity-50 text-xs lg:text-sm">{props.placeholder ?? 'Select'}</div>
          <div className="flex-shrink-0">
            <img
              src={_getBaseUrl("src/assets/icons/icon-dropdown.svg", true)}
              alt="toggle download"
              className={`${expanded ? "rotate-180" : ""}`}
            />
          </div>
        </div>
      </div>
      {expanded && (
        <div className="border border-t-0 border-ideaListGrey100 bg-white rounded-bl-md rounded-br-md absolute bottom-0 w-full translate-y-full">
          <div className={`py-2 px-4 overflow-auto ${props.maxHeight ? "max-h-[" + props.maxHeight + "]" : "max-h-[300px]"}`}>
            <div>{props.children}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DropDown;
